export enum ClientSuffix {
  EID_LEGAL = '_legal',
  EID_NATURAL = '_natural',
  SSI = 'ssi'
}
